import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
export function useHasImageLoaded(options) {
  var src = options.src,
      srcSet = options.srcSet;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasLoaded = _useState2[0],
      setHasLoaded = _useState2[1];

  useEffect(function () {
    if (!src && !srcSet) {
      return;
    }

    var active = true;
    var image = new window.Image();
    image.src = src;

    image.onload = function () {
      if (active) {
        setHasLoaded('loaded');
      }
    };

    image.onerror = function () {
      if (active) {
        setHasLoaded('error');
      }
    }; // eslint-disable-next-line consistent-return


    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return hasLoaded;
}